// extracted by mini-css-extract-plugin
export default {"box-content":"HistoryDetail_box-content__Cx1Gb","box-name":"HistoryDetail_box-name__x7cbA","btn-attachment":"HistoryDetail_btn-attachment__t6Uch"};